import { render, staticRenderFns } from "./CreateOTView.vue?vue&type=template&id=deb4c8d8&lang=pug"
import script from "./CreateOTView.vue?vue&type=script&lang=js"
export * from "./CreateOTView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports